import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import type { FaqItem } from '../../types/salesPage';
interface FaqAccordionProps {
  items: FaqItem[];
}
export function FaqAccordion({
  items
}: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="border-t border-white/[0.07] bg-ink px-5 py-14 sm:px-6 md:py-20" data-id="element-90" data-mp="l62t4h29mro">
      <div className="mx-auto max-w-3xl" data-id="element-91" data-mp="t9bk1h8wotmr">
        <header className="text-center" data-id="element-92" data-mp="t88sr87o8p6b">
          <h2 id="faq-title" className="font-serif text-[24px] font-bold leading-tight text-parchment sm:text-[30px] md:text-[36px]" data-id="element-93" data-mp="f9sqpukr7mui">
            Preguntas que todo hombre hace antes de decidir
          </h2>
        </header>

        <ul className="mt-9 divide-y divide-white/[0.08] border-y border-white/[0.08]" data-id="element-94" data-mp="2zyggv0biqnn0">
          {items.map((item, i) => {
          const isOpen = openIndex === i;
          return <li key={item.question} data-id="element-95" data-mp="1qhrtbynb3mla" data-mpi={i}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft" data-id="element-96" data-mp="1qitbso6njbd1">
                  <span className="font-serif text-[17px] font-semibold text-ivory md:text-[19px]" data-id="element-97" data-mp="29dhvblv8oiz6">
                    {item.question}
                  </span>
                  <motion.span animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.2
              }} className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-gold/40 text-gold" data-id="element-98" data-mp="2j4cj4uo4vqmq">
                    <Plus aria-hidden="true" className="h-4 w-4" data-id="element-99" data-mp="2n8afixm2qnc3" />
                  </motion.span>
                </button>

                <AnimatePresence initial={false} data-id="element-100" data-mp="1kve6js347xhl">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-101" data-mp="1ptpkof0g0u5m">
                      <p className="pb-6 pr-2 text-[14.5px] font-light leading-[1.75] text-smoke sm:pr-10" data-id="element-102" data-mp="28i48ktfgrs27">
                        {item.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}